module.exports = __webpack_public_path__ + "static/media/brands_aquarong.259e7e60.svg";